import { FC } from 'react'
import CustomPagesLayout from './layout'
import CustomPagesLogic from './logic'

interface CustomPagesProps {
  maxItemsInline: number
}

const CustomPages: FC<CustomPagesProps> = ({ maxItemsInline }) => {
  return (
    <CustomPagesLogic
      Wrapper={CustomPagesLayout}
      maxItemsInline={maxItemsInline}
    />
  )
}

export default CustomPages
